import React from "react";
import './FooterAll.css';
import FooterTwitter from "../../../static/img/Footer/twitter.svg";
import ico_gurs from "../../../static/img/Footer/ico_gurs.png";
import FooterAllHref from "./FooterAllHref/FooterAllHref";
import gql from "graphql-tag";
import ChangeLink from "../../ChangeLink/ChangeLink";
import QueryCurrentPrizeInfo from "./QueryCurrentPrizeInfo/QueryCurrentPrizeInfo";



function FooterAllGatsby(props) {
    let ThisYear = new Date();
    return (
        <footer className="FooterAll StandartPage">
            <div className="FooterAllTop">
                <div className="FooterAllTopElementTwitter"><a href="https://twitter.com/Profiforex1" target='_blank' rel="noopener noreferrer" ><img src={FooterTwitter}  alt='Ifyoudontseeimages' width='34px'/></a></div>
                <div className="FooterAllTopElementGurs">
                    <div  className="footer_gursIMG"><a href="http://gurs-fx.com/" target='_blank' rel="noopener noreferrer" > <img src={ico_gurs} alt='alt'/></a></div>
                    <div ><div className="footer_gursTitle">GURS Protected</div>
                        <div className="footer_gursText">Global Unite Responsibility System</div>
                        <div className="footer_gursText"><ChangeLink lang={props.lang} to='/certificate'>Certificate</ChangeLink></div></div>
                </div>
                <div className="FooterAllTopElementAward">
                    <div className="FooterAllRightAward">
                        <QueryCurrentPrizeInfo lang={props.lang}/>
                    </div>
                    <div className="FooterAllRightText">
                        Excellence in <br/>
                        FX Services
                    </div>
                </div>
                <div className="FooterAllTopElementHREF">
                    <div className="FooterAllLeftBottomHREFElement">
                        <ChangeLink lang={props.lang} to='/privacy-policy'>Privacy policy</ChangeLink>
                    </div>
                    <div className="FooterAllLeftBottomHREFElement">
                        <ChangeLink lang={props.lang} to='/anti-money-laundering-policy'>Anti-Money Laundering Policy</ChangeLink>
                    </div>
                    <div className="FooterAllLeftBottomHREFElement">
                        <ChangeLink lang={'en'} to='/funds-security'>Funds Safety</ChangeLink>
                    </div>
                    <div className="FooterAllLeftBottomHREFElement">
                        <ChangeLink lang={'en'} to='/return-policy'>Return Policy</ChangeLink>
                    </div>
                </div>
                <div className="FooterAllTopElementCopyright">
                    © 2010-{ThisYear.getFullYear()} Profiforex Corp.
                </div>

                <div className="FooterAllTopElementText">Trading in the foreign exchange market might carry potential rewards, but there are also potential risks.
                    You must be aware of the risks and be willing to accept them in order to trade in the foreign exchange market. Don't trade with money you can't afford to lose.
                </div>
            </div>
            <div className="FooterAllMenu">
                <div className="StandartPageIn">
                    <FooterAllHref lang={props.lang} in404={props.in404}/>
                </div>
            </div>
        </footer>
    )}

export default FooterAllGatsby





